import React, { useEffect, useState } from "react";
import Button from "../../../../../components/common-components/button/Button";
import EyeIcon from "../../../../../components/icons/vectors/EyeIcon";
import { HEADING } from "../../../../../components/common-components/heading/Constants";
import Heading from "../../../../../components/common-components/zoom/components/heading/Heading";
import { componentKey as PatientDashboardComponentKey, setBundlesData } from "../../PatientDashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import FHIRBundleViewer from "./FHIRBundleViewer/FHIRBundleViewer";
import { BUTTON_VARIANTS } from "../../../../../components/common-components/button/Constants";
import General from "../../../../../libs/utility/General";


function ViewRecords({handleCancle, custumHeight="max-h-[60vh]"}) {
    const { bundlesData } = useSelector((state) => state[PatientDashboardComponentKey]);
    const [isViewRecordOpen, setIsViewRecordOpen] = useState(false);
    const [selectedViewRecord, setSelectedViewRecord] = useState({})
    const [selectedRecordTitle, setSelectedRecordTitle] = useState("");
    const dispatch = useDispatch();
    
    const records = bundlesData?.flatMap(bundle => {
        if (!bundle?.entry) return [];
    
        return bundle.entry
            .map(entry => {
                if (entry.resource?.resourceType === "Composition") {
                    return {
                        id: bundle.id,
                        resourceType: entry?.resource?.title || "Health Information",
                        lastUpdated: General.formatToIST(bundle.meta?.lastUpdated)
                    };
                }
                return null;
            })
            .filter(Boolean);
    });

    useEffect(() => {
        return () => dispatch(setBundlesData([]))
    }, [dispatch])

    return (
        <>
            <div className={`w-full flex flex-col gap-6 p-2 ${custumHeight}`}>
                <Heading type={HEADING.H1} className="text-2xl font-bold text-gray-900 border-b pb-2">Patient Records</Heading>
                <div className="space-y-2 overflow-y-auto rounded-xl met-scrollbar">
                    {records?.length > 0 ? records.map((record, idx) => (
                        <div
                            key={record.id + idx}
                            className="flex justify-between items-center p-2 bg-white shadow-md rounded-lg border border-gray-200 hover:shadow-lg transition-all duration-200"
                        >
                            <div className="flex items-center gap-4">
                                <span className="px-4 py-1 text-sm font-semibold bg-blue-200 text-met-primary rounded-lg">
                                    {record.resourceType}
                                </span>
                                <div className="text-gray-600 text-sm flex items-center gap-1">
                                    <span>{record.lastUpdated}</span>
                                </div>
                            </div>
                            <Button 
                                variant="outline" 
                                className="flex items-center gap-2 px-4 py-2 border-met-primary text-met-primary hover:bg-blue-100 rounded-lg transition-all"
                                onClickCb={() => {
                                    setSelectedViewRecord(bundlesData.find((bundle) => bundle.id === record.id))
                                    setIsViewRecordOpen(true);
                                    setSelectedRecordTitle(record.resourceType)
                                }}
                            >
                                <EyeIcon/> View
                            </Button>
                        </div>
                    )) : (
                        <div className="text-gray-500 text-center py-10 text-lg font-medium">No records available</div>
                    )}
                </div>
            </div>
            <div className="flex justify-end items-center mr-[28px]" style={{gap: "38rem"}}>
                <div>We didn't receive all the records. So some might be missing.</div>
                <Button 
                    onClickCb={handleCancle} 
                    variant={BUTTON_VARIANTS.OUTLINED}
                >Close</Button>
            </div>
            {isViewRecordOpen && 
                <FHIRBundleViewer 
                    title ={selectedRecordTitle}
                    bundle={selectedViewRecord} 
                    close={() => {
                        setIsViewRecordOpen(false)
                        setSelectedViewRecord({})
                    }}
                />
            }
        </>
    );
}

export default ViewRecords;
